/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCalendarStar} from '@fortawesome/pro-duotone-svg-icons';

const EventsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faCalendarStar} {...props} />
);

export default EventsIcon;
